export default __webpack_public_path__ + "static/media/flag-france.cb2bd336.svg";